import { Tabs } from "@base-ui/react/tabs";
import type { MenuSection } from "../../content/industry";
import { useMenuCategories } from "../../content/items";
import { SectionHeading } from "./SectionHeading";

/**
 * Carta con categorías en pestañas (Tabs de Base UI): roles ARIA, flechas izquierda/derecha e Inicio/Fin ya resueltos
 * por la librería; aquí solo se dibuja el contenido de cada categoría.
 */
export function MenuBoard({ section }: { section: MenuSection }) {
  const categories = useMenuCategories(section);
  if (categories.length === 0) return null;
  return (
    <section id={section.id} className="ix-section ix-menu" aria-labelledby={`${section.id}-title`}>
      <div className="ix-container">
        <SectionHeading id={section.id} eyebrow={section.eyebrow} title={section.title} text={section.text} />
        <Tabs.Root defaultValue={0}>
          <Tabs.List className="ix-tabs" aria-label="Categorías de la carta">
            {categories.map((item, index) => <Tabs.Tab key={item.name} value={index}>{item.name}</Tabs.Tab>)}
          </Tabs.List>
          {categories.map((category, index) => <Tabs.Panel key={category.name} value={index} className="ix-menu-panel">
            <ul className="ix-menu-list">{category.items.map(item => <li key={item.name}>
              <div className="ix-service-line"><h3>{item.name}</h3><span aria-hidden="true" className="ix-leader" /><strong>{item.price}</strong></div>
              <p>{item.text}</p>
              {item.tags?.length ? <ul className="ix-tags">{item.tags.map(tag => <li key={tag}>{tag}</li>)}</ul> : null}
            </li>)}</ul>
          </Tabs.Panel>)}
        </Tabs.Root>
        <p className="ix-note">{section.note}</p>
      </div>
    </section>
  );
}
